export enum EstadosTareaEnum {
    Pendiente = '1',
    Activa = '2',
    RealizadaFinalizada = '3',
    Cancelada = '4'
}
